import React from 'react'
import IconErrorLight from '../Resources/svg/Icons/IconErrorLight'

const CloudMessage = ({
    mainMessage,
    secondaryMessage,
    buttonText,
    onClick,
}) => {
    return (
        <div className="cloudmessage">
            <div className="cloudmessage__content">
                {/* <img
                    className="cloudmessage__image"
                    src={image}
                    alt={altImage}
                /> */}
                <IconErrorLight className="cloudmessage__image"/>
                <p className="cloudmessage__title">{mainMessage}</p>
                <p className="cloudmessage__text">{secondaryMessage}</p>
                {buttonText && (
                    <button
                        className="cloudmessage__redButton"
                        onClick={onClick}
                    >
                        {buttonText}
                    </button>
                )}
            </div>
        </div>
    )
}

export default CloudMessage
